// extracted by mini-css-extract-plugin
export default {"errorMsg":"LoanServicingEscrowAccrualsPage_errorMsg__UEOuk"};